export default {
  kanbanData: []
}